export default {
  kanbanData: []
}